import { useAuthState, useRedirect } from "react-admin";
import Snackbar from "@material-ui/core/Snackbar";
import MuiAlert from "@material-ui/lab/Alert";
import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import Paper from "@material-ui/core/Paper";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import Card from "@material-ui/core/Card";
import SearchBox from "./SearchBox";
import Mentor from "./Mentor";
import AppBar from "../../Components/header";
import Footer from "../../Components/Footer";
import { CardContent } from "@material-ui/core";
import Button from "@material-ui/core/Button";
import { useAuthenticated } from "react-admin";
import { Link } from "react-router-dom";
import AppProvider from "./../../Components/bootstrap";

const PersonIcon = require("../../images/person.png");

const useStyles = makeStyles((theme) => ({
  root: {
    background: "linear-gradient(45deg, #EF8354 30%, #EF8354 90%)",
    borderRadius: 3,
    border: 0,
    color: "white",
    height: 38,
    width: 174,
  },
  label: {
    textTransform: "capitalize",
  },
  paper: {
    background: "transparent",
    boxShadow: "none",
  },
  heading: {
    marginTop: "8%",
    color: " #2D3142",
    textAlign: "center",
  },
  subText: {
    textAlign: "left",
    maxWidth: "36vw",
  },
  subText1: {
    marginTop: "3%",
    color: "#BFC0C0",
    textAlign: "center",
  },
  card: {
    background: "#fff",
    maxWidth: "50vw",
    maxHeight: "30vh",
    borderRadius: 10,
  },
}));

function Alert(props) {
  return <MuiAlert elevation={6} variant="filled" {...props} />;
}
const Content = () => {
  useAuthenticated();
  const { loaded, authenticated } = useAuthState();
  const redirect = useRedirect();

  if (loaded && authenticated) {
    const user = JSON.parse(
      localStorage.getItem(`Parse/${process.env.REACT_APP_APP_ID}/currentUser`)
    );
    console.log("Local Storage User", user);
    if (user.role === "admin") redirect("/User");

    return (
      <div>
        <AppBar />
        {!user.isMentor ? (
          <LandingPage user={user} />
        ) : user.profileVerified ? (
          <LandingPage user={user} />
        ) : (
          <WaitingArea user={user} />
        )}
      </div>
    );
  }

  return <LoginMessageBoard />;
};

const LoginMessageBoard = () => {
  const classes = useStyles();
  return (
    <Grid
      container
      direction="column"
      alignItems="center"
      style={{ marginTop: "10%" }}
    >
      <Grid item xs={12}>
        <Card variant="outlined" className={classes.card}>
          <CardContent>
            <Typography variant="h6" color="textSecondary">
              Looks like you are not logged in.
            </Typography>
            <Typography variant="h6" color="textSecondary">
              Kindly<a href="/login">Login </a>.
            </Typography>
            <Typography variant="h6" color="textSecondary">
              If you do not have a account, please
              <a href="/v2/signup">Sign Up </a>.
            </Typography>
          </CardContent>
        </Card>
      </Grid>
    </Grid>
  );
};

const LandingPage = ({ user }) => {
  const classes = useStyles();
  console.log("user", user);
  const [open, setOpen] = React.useState(user.OptIn === true ? false : true);
  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }

    setOpen(false);
  };
  return (
    <AppProvider>
      <Paper className={classes.paper}>
        <Grid
          container
          spacing={3}
          style={{
            paddingLeft: "8%",
            paddingRight: "8%",
            paddingTop: "5%",
          }}
        >
          <Grid item xs={12} sm={8}>
            <Typography
              variant="h1"
              style={{
                marginTop: "15%",
                color: " #2D3142",
                textAlign: "left",
                fontWeight: "bold",
                fontSize: "28px",
              }}
            >
              Hi {user.name}! Welcome to 123Mentor !!
            </Typography>
            <Typography
              color="textSecondary"
              variant="body1"
              className={classes.subText}
            >
              {user.isMentor
                ? "Happy Mentoring!"
                : "Choose a Mentor Category to get started. Happy Mentoring!!"}
            </Typography>
            <div>
              <SearchBox />
            </div>
          </Grid>
          <Grid item xs={12} sm={4}>
            <img
              src={PersonIcon}
              alt={"123Mentor"}
              style={{
                height: "80%",
                width: "100%",
                marginTop: "10%",
              }}
            />
          </Grid>
        </Grid>
      </Paper>
      <Grid container>
        <Grid item xs={12}>
          <Mentor />
        </Grid>
      </Grid>
      <div style={{ zoom: "88%" }}>
        <Footer />
      </div>
      <Snackbar open={open} autoHideDuration={10000} onClose={handleClose}>
        <Alert severity="info" onClose={handleClose}>
          Please Complete WhatsApp Onboarding Process!
        </Alert>
      </Snackbar>
    </AppProvider>
  );
};

const WaitingArea = ({ user }) => {
  console.log("user", user);

  const classes = useStyles();
  const [open, setOpen] = React.useState(user.OptIn === true ? false : true);
  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }

    setOpen(false);
  };

  return (
    <Grid
      container
      direction="column"
      alignItems="center"
      style={{ marginTop: "10%" }}
    >
      <Grid item xs={12}>
        <Card variant="outlined" className={classes.card}>
          <CardContent>
            <Typography variant="h6" color="textSecondary">
              Thank you for signing up to 123mentor, you are one step away from
              approval to becoming a Mentor. Please click the link so you can
              create a profile.
              {/* Hi {user.name}! Thank you for choosing 123mentor for your
              expertise. Your Mentor Application is under review. Kindly contact
              support@123mentor.com for any queries you may have. Happy
              Mentoring !! */}
            </Typography>
          </CardContent>
        </Card>
      </Grid>
      <Link
        to="/myprofile"
        style={{
          textDecoration: "none",
        }}
      >
        <Button
          variant="contained"
          style={{
            borderRadius: "10vh",
            marginTop: "2vh",
            backgroundColor: "#F99217",
            color: "white",
          }}
        >
          My Profile
        </Button>
      </Link>
      <Snackbar open={open} autoHideDuration={80000} onClose={handleClose}>
        <Alert severity="info" onClose={handleClose}>
          Please Complete WhatsApp Onboarding Process!
        </Alert>
      </Snackbar>
    </Grid>
  );
};

export default Content;
